import { render } from "./EventResult.vue?vue&type=template&id=4808c641&scoped=true"
import script from "./EventResult.vue?vue&type=script&lang=js"
export * from "./EventResult.vue?vue&type=script&lang=js"

import "./EventResult.vue?vue&type=style&index=0&id=4808c641&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4808c641"]])

export default __exports__